import { api } from '@/api/api-client.config.ts';
import { Pickem } from '@/@types/api.types.ts';
import { useMutation } from '@tanstack/react-query';

const createPickem = (pickem: Pickem) => api.post(`/admin/pickems`, pickem);

export const useCreatePickemMutation = () => {
  return useMutation({
    mutationKey: ['createPickem'],
    mutationFn: createPickem,
  });
};
